module.exports = __webpack_public_path__ + "img/图片3.d393d3a4.png";